export const TransitionConfig = {
  slideXTransition: {
    enterDuration: 500,
    leaveDuration: 200
  },
  slideYTransition: {
    enterDuration: 500,
    leaveDuration: 200
  }
};